<template>
    <section class="section is-medium is-white has-text-centered is-long">
        <div class="container">
            <div class="columns is-centered">
                <div class="column">
                    <h1 class="title is-size-3"> Skill & Tools </h1>
                    <div class="columns is-centered">
                        <div class="column is-one-third" v-for="skill in skills" :key="skill.id">
                            <div class="card is-br-25">
                                <header class="card-header">
                                    <div class="column">
                                        <div class="title">
                                            <img :src="require(`@/assets/img/svg/${skill.image}`)" :alt="skill.title" class="is-50x50">
                                        </div>
                                        <div class="subtitle">
                                            {{skill.title}}
                                        </div>
                                    </div>
                                </header>
                                <div class="card-content">
                                    <div class="content">
                                        <ul>
                                            <li v-for="(list, index) in skill.lists" :key="index">{{list}}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: ['skills']
}
</script>
